// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-default-js": () => import("/opt/build/repo/skookum-website/src/templates/default.js" /* webpackChunkName: "component---src-templates-default-js" */)
}

